import React, { useContext } from 'react';
import { Grid, Icon } from 'semantic-ui-react';
import DataContext from '../contexts/DataContext';

const CreditStats = () => {
  const { team } = useContext(DataContext);
  const creditStats = [
    {
      topLabel: 'Total Credits',
      value: team.creditBalance,
      bottomLabel: '',
    },
    {
      topLabel: 'On Hold Credits',
      value: team.pendingExpense,
      bottomLabel: 'For Scheduled Interviews',
    },
    {
      topLabel: 'Available Credits',
      value: team.availableCredits,
      bottomLabel: '',
    },
  ];

  return (
    <Grid stackable doubling columns={3}>
      {creditStats.map((creditStat) => (
        <Grid.Column key={creditStat.topLabel}>
          <div className="stats-item">
            <div className="label">
              <Icon name="database" />
              {creditStat.topLabel}
            </div>
            <div className="number">{creditStat.value}</div>
            <div className={`footer ${creditStat.bottomLabel === '' && 'empty-spacing'}`}>
              {creditStat.bottomLabel}
            </div>
          </div>
        </Grid.Column>
      ))}
    </Grid>
  );
};

export default CreditStats;
